import c from "../../utils/constants";

const MermaidService = function () {
  "ngInject"
  
  const init = () => {
      console.log("mermaid initialized");
      window.mermaidAPI.initialize({
          startOnLoad: false,
          flowchart:{
            useMaxWidth: false,
            htmlLabels: true
          }          
      });
  }

  const render = (id, graphDefinition, cb) => {
      window.mermaidAPI.render(id, graphDefinition, cb)
  }

  const getGraph = (diagramId) => {
    switch (diagramId) {
      case c.flowDiagrams.FACEBOOK_CHANNEL:
      return `graph TB            
        885108642(Hi Im Agent Juggle I...) --> 885108643(Helper)
        885108643 --> 885108644(Great Would you like...)
        885108644 --> 885108645(How JS works)
        885108645 --> 885108646(JS is a network that...)
        885108646 --> 885108647(No I want to  know m...)
        885108647 --> 885108648(what would you like ...)
        885108648 --> 885108649(Trust in the JS netw...)
        885108648 --> 885108651(How much it costs  h...)
        885108648 --> 885108654(something else)
        885108654 --> 885108655(where we operate)
        885108654 --> 885108657(Im ready to register)
        885108646 --> 885108659(Yes)
        885108646 --> 885108660(No Im ready to regis...)
        885108660 --> 885108661(go to)
        885108644 --> 885108662(How much will I earn...)
        885108662 --> 885108663(There is no cost to ...)
        885108663 --> 885108664(register)
        885108664 --> 885108665(go to)
        885108663 --> 885108666(know more about cost...)
        885108666 --> 885108667(How much you earn is...)
        885108667 --> 885108668(Yes I want to know m...)
        885108668 --> 885108669(what would you like ...)
        885108669 --> 885108670(trust)
        885108670 --> 885108671(go to)
        885108669 --> 885108672(where we operate)
        885108672 --> 885108673(go to)
        885108669 --> 885108674(how JS works)
        885108674 --> 885108675(go to)
        885108667 --> 885108676(No Im ready to Regis...)
        885108676 --> 885108678(go to)
        885108663 --> 885108679(something else)
        885108644 --> 885108693(Trust in the JS netw...)
        885108693 --> 885108694(Trust is super impor...)
        885108694 --> 885108695(Know more about trus...)
        885108695 --> 885108696(1 your JS profile ph...)
        885108694 --> 885108715(something else)
        885108715 --> 885108716(what do you want to ...)
        885108644 --> 885108729(Where we operate)
        885108729 --> 885108730(What is your postcod...)
        885108642 --> 885108794(Parent)
        classDef selected fill:#f9f,stroke:#333,stroke-width:4px;
        class 885108642,885108643,885108644,885108662,885108663,885108666,885108667,885108668,885108669,885108670,885108671 selected
        `;
      case c.flowDiagrams.LOCATE_HELPERS_IN_AREA_FLOW:
        return `graph TB
                A(Locate Babysitters and Nannies) --> B(Request Suburb or Postcode)
                B --> C(Display Suburb Summary)
                C --> D{Display Top 10 helpers?}
                D --> E(Yes)
                D --> F(No)
                F --> G[End]
                G --> A
                E --> H(List 10 Helpers)
                H --> I[Display Helper Profile]
                I --> J{Actions}
                J --> K(Sign Up)
                J --> L(Post Job)
                J --> M[End]
                M --> A`;
      case c.flowDiagrams.POST_JOB_FLOW:
        return `graph TB
                A(Post Job Request) --> B{Use Usual Sitters?}
                B --> C(Yes)
                B --> D(No)
                D --> F(Specify Sitter By Name)
                C --> E(When do you need a sitter?)
                F --> E
                E --> H(Specify Start Time, End time, Hourly Rate)
                H --> I(Post Job and Send Confirmation)
                I --> J(Print Receipt - If Required)
                J --> K(Rate Previous Jobs - If Any)`;
      case c.flowDiagrams.DISPLAY_PROFILE_FLOW:
        return `graph TB
                A(Display Profile) --> C(Display Summary)
                C --> D(Display Family Recommendations)
                D --> E(Display Video Interview)
                E --> J{Actions}
                J --> K(Post Job)
                J --> L(Connect)
                J --> M[End]
                M --> A`;
      default:
        return `graph TB
                A(TBD) --> C(TBD)`;
    }
  }
   
  return { init, render, getGraph };
};

export default MermaidService;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/mermaid.service.js
 **/